module.exports = {"attributes":{"width":"26","height":"26","viewBox":"0 0 26 26","xmlns":"http://www.w3.org/2000/svg"},"content":"<g fill-rule=\"nonzero\">     <path d=\"M7.68 16.22a1 1 0 0 1 .66 1.9A2 2 0 0 0 9 22h8a2 2 0 0 0 .66-3.89 1 1 0 1 1 .66-1.89A4 4 0 0 1 17 24H9a4 4 0 0 1-1.32-7.78z\"/>     <path d=\"M16 12a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v.75h2V18h2v-5.25h2V12zm2 2.75h-2V18a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-3.25H8V12a4 4 0 0 1 4-4h2a4 4 0 0 1 4 4v2.75zM13 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/conversion.svg
// module id = 1387
// module chunks = 0